import React from 'react';
import { interpolateReds } from 'd3';

import Plot from '../../components/Plot';
import PlotText from '../../components/PlotText';

function Temperature({ size, sensors }) {
  return (
    <Plot size={size}>
      {({ xScale, yScale }) => sensors.map(sensor => (
        <PlotText
          key={sensor.lsid}
          x={xScale(sensor.x)}
          y={yScale(sensor.y)}
          fill={interpolateReds(sensor.temp / 100)}
        >
          {sensor.temp.toFixed(1)}°F
        </PlotText>
      ))}
    </Plot>
  )
}

Temperature.defaultProps = {
  offset: {
    x: 0,
    y: 0,
  },
}

export default Temperature;



// WEBPACK FOOTER //
// ./src/plots/Temperature/Temperature.component.js